<template>
  <div class="home-container">
    <!-- <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading> -->
    <!-- <SkeletonLoading v-if="isLoading"/> -->
    <div class="setSellerScreen" @click.stop="hidePopUp">
      <img
        @click.stop="showStory"
        src="@/assets/imgs/popup.png"
        class="popupBtn"
        alt=""
      />
      <div class="title">
        <img src="@/assets/imgs/Giftsa-03.png" class="welcom-bg" alt="" />
        <div class="story" id="giftsaStory">
          <h5>
            मैं Giftsa हूं मेरा सपना है कि,आपके अपनों की जिंदगी का हर खूबसूरत
            मौका और भी यादगार बनें और आप भारत में कहीं से भी रिश्तों को प्यार की
            सौगात दें सकें ताकि दिलों की डोर बंधी रहे।
          </h5>

          <h5>
            मेरी आकांक्षा है कि हमारे ‘Digital India’ के सपने को साकार होते
            देखूं ताकि रास्ते की दूरियाँ ख़ुशियों के बीच ना आए और हर चेहरे को
            मुस्कुराने की वजह मिले।
            <br>
            for help call us <b>9311065819</b>
          </h5>
        </div>
      </div>
      <div class="input-panel">
        <input
          type="number"
          placeholder="Enter shop mobile no."
          class="shopNumber"
          v-model="userNumber"
          required
        />
        <button @click.stop="fetchStudio" class="Go">GO</button>
      </div>

      <img src="@/assets/imgs/Giftsa.gif" class="gif-bg" alt="" />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.home-container {
  width: 100%;
  height: 100%;
  background-color: black;
  .setSellerScreen {
    background-color: white;
    display: block;
    width: 100%;
    height: 100%;
    img.popupBtn {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
      margin-right: -85%;
    }
    .title {
      position: relative;
      top: 5rem;
      width: 100%;
      height: 125%;
      img {
        height: 100px;
      }
    }
    .story {
      visibility: hidden;
      background-color: white;
      width: 78%;
      top: 50px;
      left: 2.3rem;
      position: absolute;
      border: solid 1px orangered;
      border-radius: 10px;
      z-index: 50;
      h5 {
        font-size: 0.7rem;
        padding: 5px 5px 0 5px;
        line-height: 1rem;
      }
    }
    .story::after {
      content: "";
      position: absolute;
      top: -11px;
      left: 32%;
      border-width: 5px;
      margin-left: -5px;
      border-style: solid;
      border-color: transparent transparent orangered transparent;
    }
    .show {
      visibility: visible;
      -webkit-animation: fadeIn 1s;
      animation: fadeIn 1s;
    }
    @-webkit-keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  }
  .input-panel {
    display: inline-flex;
    top: 180px;
    height: 25%;
    position: relative;
  }

  input.shopNumber {
    bottom: 2rem;
    width: 80%;
    height: 30px;
    background: transparent;
    border: none;
    outline: none;
    border-bottom: 1px solid black;
    font-size: 0.9rem;
  }
  ::placeholder {
    color: black;
    opacity: 1;
  }
  button.Go {
    bottom: 0.5rem;
    width: 25%;
    height: 35px;
    background: #ffaa00;
    color: #fff;
    border: none;
    font-size: 16px;
    border-radius: 5px;
    margin-left: 10px;
    margin-top: -3px;
    text-transform: uppercase;
    outline: none;
  }
  img.gif-bg {
    margin-top: 75%;
    position: relative;
    width: 100%;
    height: 40%;
  }
}
</style>
<script>
import SkeletonLoading from "../views/SkeletonLoading";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState, mapGetters } from "vuex";
import router from "@/router";
import VueQrReader from "vue-qr-reader/dist/lib/vue-qr-reader.umd.js";
import Swal from "sweetalert2";
export default {
  name: "Home",
  components: {
    Loading,
    SkeletonLoading,
    VueQrReader,
  },
  data() {
    return {
      userNumber: null,
      showWelcome: false,
      showScanner: false,
      showRefer: false,
      showSetSeller: true,
      applink: null,
      userShopName: null,
      referUserNumber: null,
    };
  },
  created() {
    if (localStorage["seller"]) {
      if (JSON.parse(localStorage["seller"]).id) {
        this.showSetSeller = false;
        this.dashboard();
        this.$store.commit(
          "sellerModule/setSeller",
          JSON.parse(localStorage["seller"])
        );
        let sellerId = JSON.parse(localStorage["seller"]).customer_id;
        this.$store.dispatch("fetchCategories", this.seller.customer_id, {
          root: true,
        });
        this.$store.dispatch(
          "sellerModule/fetchSeller",
          this.seller.customer_id
        );
      } else {
        this.showWelcome = false;
      }
    }
    this.fetchCustomerByDomain();

    if (this.$store.state.token) {
      this.$router.push({ name: "dashboard" });
    }
  },

  methods: {
    fetchCustomerByDomain() {
      if (this.$store.getters["sellerModule/isCustomDomain"]) {
        this.$store.commit("setLoading", true);
        this.$store
          .dispatch("sellerModule/fetchSellerByDomain", window.location.host)
          .then(() => {
            this.$store.commit("setLoading", false);
            if (this.seller.subscription_status == true && this.seller.status != false) {
              this.dashboard();
            } else {
              Swal.fire({
                icon: "error",
                title: "Sorry",
                text: "This account is expired.Kindly recharge",
              });
              localStorage.clear();
            }
          });
      }
    },
    fetchStudio() {
      if (
        !Number.isInteger(parseInt(this.userNumber)) ||
        this.userNumber.toString().length != 10
      ) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Number!",
          text: "Try again",
        });
        return false;
      }
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("sellerModule/fetchSellerByPhone", this.userNumber)
        .then(() => {
          this.$store.commit("setLoading", false);
          if (this.seller.subscription_status == true && this.seller.status != false) {
            this.dashboard();
          } else {
            Swal.fire({
              icon: "error",
              title: "Sorry",
              text: "This account is expired.Kindly recharge",
            });
            this.$router.push("/sellerlogout");
          }
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
          Swal.fire({
            title: "WARNING!",
            text:
              "This mobile number "+this.userNumber+" does not belong to our partner shop.Please check and enter again.",
            icon: "warning",
          });
        });
    },
    fetchCheckProducts() {
      console.log("fetchCheckProducts clicked");
      this.$store.commit("setLoading", true);
      this.$store.dispatch("fetchCheckProducts").then(() => {
        this.$store.commit("setLoading", false);
        this.checkproducts();
      });
    },
    openScanner() {
      this.showScanner = true;
    },
    openQr() {
      this.showRefer = false;
      this.showScanner = true;
    },
    codeArrived(event) {
      this.applink = event.split("/")[3];
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("sellerModule/fetchSellerByLink", this.applink)
        .then(() => {
          this.$store.commit("setLoading", false);
          this.dashboard();
        });
    },
    openRefer() {
      this.showRefer = true;
      this.showScanner = false;
    },

    dashboard() {
      router.push({
        name: "dashboard",
        params: {},
      });
    },
    showStory() {
      let popup = document.getElementById("giftsaStory");
      popup.classList.toggle("show");
    },
    hidePopUp() {
      let popup = document.getElementById("giftsaStory");
      popup.classList.remove("show");
    },
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      seller: (state) => state.sellerModule.seller,
    }),
  },
};
</script>
